import { render } from "./VProtocolName.vue?vue&type=template&id=779419ed&scoped=true&ts=true"
import script from "./VProtocolName.vue?vue&type=script&lang=ts"
export * from "./VProtocolName.vue?vue&type=script&lang=ts"

import "./VProtocolName.vue?vue&type=style&index=0&id=779419ed&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-779419ed"]])

export default __exports__